import { BaseApiService } from '@/services/base-service';
import {
  ApiPagination, BaseResponse, Filters, FiltersPagination,
} from '@/types';
import { GlobalSearch } from '../types';

interface SearchList extends BaseResponse, ApiPagination {
  data: {
    items: GlobalSearch.SearchItems[],
    available_search_pages: GlobalSearch.SearchPages[],
    search: string,
  }
}

export class GlobalSearchService extends BaseApiService {
  private readonly base_path = 'search';

  async get_search(filters: FiltersPagination<Filters>): Promise<SearchList> {
    const payload = filters;

    const { data } = await this.http_client.get<SearchList>(this.base_path, {
      params: {
        filters: payload.filters,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    return data;
  }
}
